import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getSupplementResponseStatuses } from '@api/lookups';
import { ISupplementResponseStatus } from '@interfaces/lookups';

export const handleGetSupplementResponseStatuses = createAsyncThunk<
  AxiosResponse<ISupplementResponseStatus[]>,
  void
>('getSupplementResponseStatuses', getSupplementResponseStatuses);
